document.addEventListener('click', function (e) {
  const button = e.target.closest('.quick-view-button');
  if (!button) return;

  e.preventDefault();

  const handle = button.dataset.productHandle;
  const productUrl = button.dataset.productUrl;

  const modal = document.getElementById('QuickViewModal');
  const content = document.getElementById('QuickViewContent');

  modal.classList.remove('hidden');
  content.innerHTML = 'Loading…';

  document.body.classList.add('quick-view-loading');
  document.body.classList.add('overflow-hidden');

  let fetchUrl = '';

  // ✅ Proper Shopify Markets compatible URL
  if (handle) {
    fetchUrl = `${window.Shopify.routes.root}products/${handle}?view=quick-view`;
  }

  // ✅ Full product URL support
  else if (productUrl) {
    const url = new URL(productUrl, window.location.origin);

    // Ensure current market/language prefix exists
    const root = window.Shopify.routes.root;

    if (!url.pathname.startsWith(root)) {
      url.pathname = `${root.replace(/\/$/, '')}${url.pathname}`;
    }

    url.searchParams.set('view', 'quick-view');

    fetchUrl = url.toString();
  }

  // ✅ Safety check
  if (!fetchUrl) {
    console.error('Quick view: no product handle or URL found');
    document.body.classList.remove('quick-view-loading');
    document.body.classList.remove('overflow-hidden');
    modal.classList.add('hidden');
    return;
  }

  fetch(fetchUrl)
    .then((res) => res.text())
    .then((html) => {
      content.innerHTML = html;
      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }
      document.body.classList.remove('quick-view-loading');
    })
    .catch((err) => {
      console.error(err);

      content.innerHTML = 'Failed to load product.';
      document.body.classList.remove('quick-view-loading');
    });
});

document.addEventListener('click', function (e) {
  if (
    e.target.classList.contains('quick-view-overlay') ||
    e.target.classList.contains('quick-view-close')
  ) {
    document.getElementById('QuickViewModal').classList.add('hidden');

    document.body.classList.remove('quick-view-loading');
    document.body.classList.remove('overflow-hidden');
  }
});